import { jsx, jsxs } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Positioning } from "../../foundations/positioning.es.js";
import CircularProgress from "../../../node_modules/@mui/material/CircularProgress/CircularProgress.es.js";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { Typography } from "../typography/typography.es.js";
function Progress({
  hideLabel,
  value,
  labelSize,
  ...rest
}) {
  if (hideLabel) {
    return /* @__PURE__ */ jsx(CircularProgress, { value, ...rest });
  }
  return /* @__PURE__ */ jsxs(Box, { position: Positioning.relative, display: Displaying.inlineFlex, children: [
    /* @__PURE__ */ jsx(CircularProgress, { value, ...rest }),
    /* @__PURE__ */ jsx(Box, { top: 0, left: 0, bottom: 0, right: 0, display: Displaying.flex, alignItems: Alignment.center, justifyContent: Alignment.center, position: Positioning.absolute, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", component: "div", color: "textSecondary", fontSize: labelSize, children: `${Math.round(value)}%` }) })
  ] });
}
export {
  Progress
};
//# sourceMappingURL=progress.es.js.map
